import { CustomErrorResponse } from "../shared";

export class CustomError extends Error {
  statusCode: number;
  timestamp: number;
  errorCode?: string;

  constructor(data: CustomErrorResponse) {
    super(data.message);
    this.statusCode = data.statusCode;
    this.timestamp = data.timestamp;
    this.errorCode = data.error;
  }
}
